import { ICreateGlobalItemRequest, ICreateGlobalItemRequestData } from 'src/api/createGlobalItem/types';
import { IGlobalItem } from '../../types';
import { formatFlagsToRegulatoryStatements } from 'src/utils/regulatory-statements';
import { ItemType } from '@weareopenr/types';

export const formatGlobalItemPayload = ({
  name,
  consumer_name,
  description,
  tax_rate,
  plu,
  recipe_id,
  type,
  image,
  ranges,
  deposit_return_scheme,
  age_verification,
  is_hfss,
  party_size,
}: IGlobalItem): ICreateGlobalItemRequest => {
  const dataPayload: ICreateGlobalItemRequestData = {
    name,
    description,
    consumer_name: consumer_name || null,
    plu: plu || null,
    type,
    ...(recipe_id ? { recipe_id } : {}),
    is_standalone: !(type === ItemType.MODIFIER),
    tax_rate: parseFloat(tax_rate),
    ...(deposit_return_scheme
      ? { deposit_return_scheme: deposit_return_scheme !== null ? parseFloat(deposit_return_scheme) : null }
      : {}),
    ...(ranges?.length ? { ranges: ranges } : {}),
    ...formatFlagsToRegulatoryStatements({ is_hfss, age_verification }),
    party_size: party_size ?? null,
  };

  return {
    data: JSON.stringify(dataPayload),
    ...(image && { files: image }),
  };
};
